import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import Vue from 'vue';
import App from './App.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faArrowLeft, faSearch, faAngleUp, faAngleDown, faImages, faTimes, faDownload, faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';

library.add(faArrowLeft)
library.add(faSearch)
library.add(faAngleUp)
library.add(faAngleDown)
library.add(faImages)
library.add(faTimes)
library.add(faDownload)
library.add(faEdit)
library.add(faSave)

Vue.component('font-awesome-icon', FontAwesomeIcon)

miniToastr.init()

function toast ({title, message, type, timeout, cb}) {
  return miniToastr[type](message, title, timeout, cb)
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
}

Vue.use(VueNotifications, options)

Vue.config.productionTip = false;
Vue.prototype.UrlBase = '/carta.php';
Vue.prototype.UrlAdmin = '/admin.php';
Vue.prototype.UrlImgDrive = 'https://lh3.google.com/u/0/d/'

new Vue({
  render: h => h(App),
}).$mount('#app')
